import React from 'react'
import styles from './PriceForm.module.css'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { CurrencySelectField } from 'components/Shared/CurrencySelectField'

export function PriceForm ({ name, disabled }) {
  return <div className={styles.containerRow}>
    <FieldComponent fieldName={`${name}.price.amount`}
                    label={'form.order.transaction.price.amount'}
                    type="number"
                    className={styles.valueField}
                    disabled={disabled}
    />
    <div className={styles.fieldHorizontalSeparator}/>
    <CurrencySelectField fieldName={`${name}.price.currencyCode`}
                         label={'form.order.transaction.price.currencyCode'}
                         className={styles.currencyField}
                         disabled={disabled}
    />
  </div>
}
